$(document).on "turbolinks:load", () ->
  if $('#inward_dc_side_panel').find('#inward_dc_show').length
     $ -> window.open_show_modal()

$(document).on 'click', '.ulsa-panel-backdrop-inward-customer', (e) ->
  $('.ulsa-panel-wrap-inward-customer').css('transform', 'translateX(100%)')
  $('.ulsa-panel-backdrop-inward-customer').css('transform', 'translateX(100%)')
